const React = require('react');
const classnames = require('classnames');
const helper = require('../../helper/dish-helper');
import HttpsProtocolImage from '../../component/common/https-protocol-image';
import BuildOrderBtn from './build-order-btn.jsx';
import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import dishMenuMessages from '../../intl/messages/dish-menu';
import globalMessages from '../../intl/messages/global';
import { DishTheme, SiglePrivTypes, INDUSTRY } from '../../helper/const.js';
import { formatPrice } from '../../helper/common-helper.js';
import { getIndustryFromBody } from '@helper/industry-helper';
const shallowCompare = require('react-addons-shallow-compare');
const shopId = helper.getUrlParam('shopId');
const type = helper.getUrlParam('type');

require('./dish-list-item.scss');

module.exports = React.createClass({
  displayName: 'DishListItem',
  contextTypes: {
    brandType: React.PropTypes.string,
  },
  propTypes: {
    dishData: React.PropTypes.object.isRequired,
    sameRuleDishList: React.PropTypes.array,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    onPropsBtnTap: React.PropTypes.func.isRequired,
    onImageBtnTap: React.PropTypes.func.isRequired,
    diningForm: React.PropTypes.number,
    marketList: React.PropTypes.object,
    theme: React.PropTypes.string,
    highLightName: React.PropTypes.string,
    hotTag: React.PropTypes.bool,
    num: React.PropTypes.number,
    showHandleInput: React.PropTypes.func,
    isFromSearch: React.PropTypes.bool, // 是否来自于搜索
    onlyAddCounter: React.PropTypes.bool,
    needImgWidth: React.PropTypes.number,
    isHDL: React.PropTypes.bool,
  },

  getInitialState() {
    return {};
  },
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },

  onBtnTap(newCount, increment) {
    const { dishData, onOrderBtnTap, onPropsBtnTap } = this.props;
    // const count = helper.getDishesCount([dishData])
    // if (increment < 0 && dishData.id == sessionStorage.getItem('reducePriceKey') && count-1 < 1) {
    //   sessionStorage.removeItem('reducePriceKey');
    //   sessionStorage.removeItem('reducePrice');
    //   localStorage.removeItem('lastOrderedDishes')
    // }
    if (increment) {
      onOrderBtnTap(dishData, increment);
    } else {
      onPropsBtnTap(dishData);
    }
    this.saveSearchHistory(dishData);
  },

  saveSearchHistory(dishData) {
    const { isFromSearch } = this.props;

    if (isFromSearch) {
      const obj = {};
      obj[shopId] = dishData.name;
      const searchedDataFromLocalHistory = JSON.parse(localStorage.searchedDataFromLocalHistory || '{}');
      let sd = searchedDataFromLocalHistory[shopId];
      const sdArray = (searchedDataFromLocalHistory[shopId] || '').split(',');

      if (sd) {
        const position = sdArray.indexOf(dishData.name);
        if (position !== -1) {
          // 如果找到了就提前
          delete sdArray[position];
          sd = sdArray.filter(item => !!item).join(',');
        }

        let fillsd = `,${sd}`;
        if (!sd) {
          fillsd = '';
        }

        searchedDataFromLocalHistory[shopId] = `${dishData.name}${fillsd}`
          .split(',')
          .slice(0, 15)
          .join(',');
        localStorage.searchedDataFromLocalHistory = JSON.stringify(searchedDataFromLocalHistory);
      } else {
        localStorage.searchedDataFromLocalHistory = JSON.stringify(Object.assign({}, searchedDataFromLocalHistory, obj));
      }
    }
  },

  onDishImageTap() {
    const { dishData, onImageBtnTap } = this.props;
    location.hash = '#dish-desc';
    onImageBtnTap(dishData);

    this.saveSearchHistory(dishData);
  },

  isShowMemberFlag() {
    const { dishData } = this.props;

    return dishData.isMember && !dishData.isUserMember;
  },

  showHandleDishCount() {
    const { dishData } = this.props;
    this.saveSearchHistory(dishData);
  },

  buildDishName(dishData) {
    if (helper.isSingleDishWithoutProps(dishData) && Array.isArray(dishData.dishPropertyTypeInfos) && dishData.dishPropertyTypeInfos.length) {
      const properties = dishData.dishPropertyTypeInfos.map(prop => prop.properties[0].name).join(', ');
      return `${dishData.name} ${properties}/${dishData.unitName}`;
    }

    return dishData.name;
  },

  buildDishSoldNum(dishData) {
    const soldNum = parseInt(dishData.soldNum, 10);

    if (!soldNum || soldNum === 0) {
      return false;
    }

    return (
      <span className="dish-sales-volume">
        <FormattedMessage {...dishMenuMessages.monthlySales} />
        {soldNum}
      </span>
    );
  },

  // 判断是否是套餐商品
  isDishMultiInfo(dishData) {
    if (dishData && dishData['@type'] && dishData['@type'] === 'dishMultiInfo') {
      return true;
    }
    return false;
  },

  renderPrivInfo() {
    const { theme, dishData } = this.props;
    const { marketingInfos = [] } = dishData || {};
    if (theme !== DishTheme.DEFAULT || !marketingInfos.length) {
      return false;
    }

    return (
      <p className="dish-item-priv-info o-fz--11">
        {marketingInfos.map(name => (
          <span key={name}>{name}</span>
        ))}
      </p>
    );
  },

  renderHDLPrivInfo(sameRuleDishList, dishData) {
    const { theme } = this.props;
    const { singleMarketingInfos = [], isMember } = dishData || {};

    if (theme !== DishTheme.DEFAULT || !singleMarketingInfos.length || isMember) {
      return false;
    }
    const memberPrice = (dishData.isMember && `${helper.getDishMemberPriceWithSameRuleDishes(dishData, sameRuleDishList)}`) || 0;
    const formateSingleMarketingInfos = singleMarketingInfos.map(info => {
      let reduceTotal = 0;
      switch (info.type) {
        case SiglePrivTypes.DISCOUNT:
          reduceTotal = dishData.isMember && memberPrice > 0 ? memberPrice * (1 - info.value * 0.1) : dishData.marketPrice * (1 - info.value * 0.1);
          break;
        case SiglePrivTypes.REDUCE:
          reduceTotal = info.value;
          break;
        default:
          break;
      }

      return { ...info, reduceTotal };
    });

    const { name: reduceName, reduceTotal } = [].concat(formateSingleMarketingInfos).sort((a, b) => b.reduceTotal - a.reduceTotal)[0];

    return {
      part: <p className="dish-item-priv-info o-fz--11">{reduceName}</p>,
      reduceTotal,
    };
  },

  /**
   * 价格展示
   * 如果不是会员
   *    如果 是海底捞 并且 singlePrice 存在。
   */
  buildDishPriceElement(dishData, sameRuleDishList, theme, isHDL, industry) {
    const { marketPrice, discountType, memberPrice: discountValue } = dishData;
    const pricePostfix = dishData.mergedMinPrice ? formatMessage(dishMenuMessages.priceFrom) : '';
    const pricePostfixElem = dishData.mergedMinPrice ? <small>{formatMessage(dishMenuMessages.priceFrom)} </small> : false;
    const priceMultiInfoPostfix = <small>{formatMessage(dishMenuMessages.priceFrom)} </small>;
    const isShowMemberFlag = this.isShowMemberFlag();
    const memberPriceTag = this.buildMemberPriceTag(dishData, sameRuleDishList);

    const buildElements = () => {
      const singlePrice = this.renderHDLPrivInfo(sameRuleDishList, dishData).reduceTotal;
      if (!dishData.isMember) {
        if (isHDL && singlePrice) {
          return (
            <p>
              <span className="dish-item-price-number price">
                {formatPrice(marketPrice - singlePrice)}
                {this.isDishMultiInfo(dishData) ? priceMultiInfoPostfix : pricePostfixElem}
                {dishData.isMember && this.props.hotTag && memberPriceTag}
              </span>
              <span className="dish-item-price-number price-after">
                <i className="price">
                  {marketPrice}
                  {this.isDishMultiInfo(dishData) ? priceMultiInfoPostfix : pricePostfix}
                </i>
              </span>
            </p>
          );
        }
        return (
          <p>
            <span className="dish-item-price-number dish-item-price-nosub price">
              {marketPrice}
              {this.isDishMultiInfo(dishData) ? priceMultiInfoPostfix : pricePostfixElem}
              {dishData.isMember && this.props.hotTag && memberPriceTag}
            </span>
          </p>
        );
      }

      const memberPrice = `${helper.getDishMemberPriceWithSameRuleDishes(dishData, sameRuleDishList)}`;
      const prices = [memberPrice, marketPrice];
      if (isShowMemberFlag) {
        prices.reverse();
      }
      const [main, sub] = prices;
      return (
        <p>
          <span className="dish-item-price-number price">
            {main}
            {this.isDishMultiInfo(dishData) ? priceMultiInfoPostfix : pricePostfixElem}
            {dishData.isMember && this.props.hotTag && memberPriceTag}
          </span>
          <span className="dish-item-price-number price-after">
            {isShowMemberFlag ? (
              ''
            ) : (
              <i className="price">
                {sub}
                {this.isDishMultiInfo(dishData) ? priceMultiInfoPostfix : pricePostfix}
              </i>
            )}
          </span>

          {industry === INDUSTRY.TEA && !isShowMemberFlag && (discountType === 1 || discountType === 3) && !!discountValue && (
            <span className="dish-item-discount-info">
              {formatMessage(dishMenuMessages.dishMenuGetVipPrice, {
                discountValue,
              })}
            </span>
          )}
        </p>
      );
    };

    return (
      <span
        className={classnames('dish-item-price', {
          'dish-item-price-flag': isShowMemberFlag,
        })}
      >
        {buildElements()}
      </span>
    );
  },

  /**
   * 构建会员价格标签
   */
  buildMemberPriceTag(dishData, sameRuleDishList) {
    const isShowMemberFlag = this.isShowMemberFlag();
    if (!isShowMemberFlag) {
      return null;
    }

    const pricePostfix = dishData.mergedMinPrice ? formatMessage(dishMenuMessages.priceFrom) : '';
    const price = helper.getDishMemberPriceWithSameRuleDishes(dishData, sameRuleDishList);

    return (
      <p className="dish-member-price-tag">
        {formatMessage(globalMessages.vipPrice)}
        <i className="price">
          {price}
          {pricePostfix}
        </i>
      </p>
    );
  },

  highLightName(name, nameWithUnit) {
    let nameWithUnitArray = [];
    const { highLightName } = this.props;

    if (highLightName) {
      if (nameWithUnit) {
        nameWithUnitArray = nameWithUnit.split(name);
      }
      // 给高亮颜色
      const newArray = name.split(highLightName);
      const positions = [];
      const searchSubStr = (str, subStr) => {
        let pos = str.indexOf(subStr);
        while (pos > -1) {
          positions.push(pos);
          pos = str.indexOf(subStr, pos + 1);
        }
      };

      searchSubStr(name, highLightName);

      if (positions && positions.length > 0) {
        positions.forEach((item, index) => {
          newArray.splice(item - newArray[0].length - 1, 0, <span className="o-search-keyword">{highLightName}</span>);
        });
        const totalArray = newArray.map((item, index) => <span key={index}>{item}</span>);
        totalArray.push(nameWithUnitArray[1]);
        return totalArray;
      }
    }

    return nameWithUnit || name;
  },

  render() {
    const industry = getIndustryFromBody();
    const { dishData, sameRuleDishList, theme, changeShowDataItems, showHandleInput, onlyAddCounter, needImgWidth, isHDL } = this.props;
    const isClear = sameRuleDishList ? sameRuleDishList.every(dish => dish.clearStatus) : dishData.clearStatus;
    const imgUrl = theme === DishTheme.HUGE || DishTheme.BIG ? dishData.largeImgList && dishData.largeImgList[0] : dishData.smallImgUrl;
    const dishImageStyle =
      imgUrl && dishData
        ? {
            backgroundImage: `url(${HttpsProtocolImage.getFinalImageUrl(imgUrl)})`,
            height: needImgWidth,
          }
        : { height: needImgWidth };
    const dishSoldNum = this.buildDishSoldNum(dishData);
    const memberPriceTag = this.buildMemberPriceTag(dishData, sameRuleDishList);

    let marginStyle = {};
    if (theme === DishTheme.BIG) {
      marginStyle = this.props.num % 2 !== 0 ? { marginLeft: '10px' } : { marginRight: '10px' };
    }
    if (theme === DishTheme.HUGE) {
      marginStyle = { marginLeft: '15px', marginRight: '15px' };
    }
    const enableSaleNum = (type === 'WM' ? dishData.residueTotalWechat : dishData.residueTotal) || 0;
    const showSaleNum = sessionStorage.getItem('showSaleNum') === 'true' || false; // 是否开启了商品余量展示开关
    const isShowRemainderTip = enableSaleNum <= 10 && enableSaleNum > 0 && showSaleNum;

    return (
      <div className="dish-on-selling" style={marginStyle}>
        {dishData.currRemainTotal !== 0 && (
          <div className={classnames('dish-list-item', { soldout: isClear })}>
            <div
              className={classnames(
                'dish-item-img',
                {
                  'is-memberdish': industry !== INDUSTRY.TEA && dishData.isMember,
                },
                {
                  'dish-img-default': (!dishData.largeImgList || dishData.largeImgList.length === 0) && !dishData.smallImgUrl,
                },
              )}
              onTouchTap={this.onDishImageTap}
              style={dishImageStyle}
            >
              {isShowRemainderTip && (
                <div className="dish-item-img-residue">
                  <FormattedMessage {...globalMessages.onlyLeft} /> {`${enableSaleNum} ${dishData.unitName}`}
                </div>
              )}
            </div>
            <div className="dish-item-content">
              <div className="dish-item-main-body">
                <div className="dish-item-fill">
                  <span className="dish-item-name">
                    {dishData.sameDishIndexs ? (
                      <span>
                        {this.highLightName(dishData.name)}
                        {dishData.unitName !== '份' ? `/${dishData.unitName}` : ''}
                      </span>
                    ) : (
                      this.highLightName(dishData.name, helper.generateDishNameWithUnit(dishData, 'dishMenu'))
                    )}
                  </span>
                  
                  {(industry === INDUSTRY.TEA || industry === INDUSTRY.NORMAL) && theme === DishTheme.DEFAULT && !!dishData.dishDesc && (
                    <span className="dish-item-desc">{dishData.dishDesc}</span>
                  )}
                  {dishSoldNum}
                </div>
                <div className="dish-item-bottom">
                  <div className="dish-price-container">
                    {this.buildDishPriceElement(dishData, sameRuleDishList, theme, isHDL, industry)}
                    <BuildOrderBtn
                      dishData={dishData}
                      sameRuleDishList={sameRuleDishList}
                      isClear={isClear}
                      changeShowDataItems={changeShowDataItems}
                      showHandleInput={showHandleInput}
                      showHandleDishCount={this.showHandleDishCount}
                      onBtnTap={this.onBtnTap}
                      onlyAddCounter={onlyAddCounter}
                    />
                  </div>
                  {dishData.isMember && !this.props.hotTag && memberPriceTag}
                </div>
              </div>
              <div className="dish-item-ext">{isHDL ? this.renderHDLPrivInfo().part : this.renderPrivInfo()}</div>
            </div>
          </div>
        )}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/dish-list-item.jsx